import { render, staticRenderFns } from "./editdigi.vue?vue&type=template&id=9a6a20ae&scoped=true"
import script from "./editdigi.vue?vue&type=script&lang=js"
export * from "./editdigi.vue?vue&type=script&lang=js"
import style0 from "./editdigi.vue?vue&type=style&index=0&id=9a6a20ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6a20ae",
  null
  
)

export default component.exports